import { Input, Collapse, Timeline } from "antd";
import { Row, Col } from "react-bootstrap";
import defaultAvatar from "../../../../assets/images/default-avatar.png";

const { Panel } = Collapse;
const { Search } = Input;

const JournalActivite = () => {
  const onSearch = (value: string) => {
    console.log("Recherche:", value);
  };

  return (
    <div className="px-3" style={{ marginTop: "10px" }}>
      {/* Champ filtre */}
      <Search
        placeholder="Tous les collaborateurs"
        allowClear
        onSearch={onSearch}
        style={{
          width: 300,
          marginBottom: "15px",
          fontFamily: "Poppins",
          fontSize:'14px',
          fontFamily:'400',
        }}
      />
      <Collapse
        bordered={false}
        expandIconPosition="end"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1.5px solid #E3E3E3",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          color:'#0E0E0F66'
        }}
      >
        <Panel
          header={
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "20px",
                fontWeight: "500",
                color: "#070707",
              }}
            >
              Aujourd’hui
            </span>
          }
          key="1"
        >
          <div
            style={{
              borderTop: "1.5px solid #E3E3E3",
              margin: "0 -16px 16px -16px",
              paddingTop: "16px",
            }}
          >
            <Row>
              <Col md={2} style={{ marginLeft: "30px", marginTop: "15px" }}>
                <Timeline
                  items={[
                    {
                      dot: (
                        <div
                          style={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            backgroundColor: "#1677ff",
                          }}
                        />
                      ),
                      children: (
                        <span style={{ color: "#000", fontSize: 14 }}>15:23</span>
                      ),
                    },
                    {
                      dot: (
                        <div
                          style={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            backgroundColor: "#1677ff",
                          }}
                        />
                      ),
                      children: (
                        <span style={{ color: "#000", fontSize: 14 }}>09:12</span>
                      ),
                    },
                  ]}
                />
              </Col>

              <Col>
                <div
                  style={{
                    border: "0.5px solid #D7D7D7",
                    borderRadius: "5px",
                    backgroundColor: "#396AFC05",
                    width: 700,
                    height: 110,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginLeft: "30px",
                      marginTop: "15px",
                    }}
                  >
                    <img
                      src={defaultAvatar}
                      alt=""
                      style={{
                        width: 29,
                        height: 29,
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                    <span
                      style={{
                        color: "#2A2A2A",
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                      }}
                    >
                      Binta-Admin
                    </span>
                  </div>

                  <div>
                    <span
                      style={{
                        color: "#2A2A2A",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        marginLeft: "65px",
                      }}
                    >
                      Action effectuée :
                    </span>
                    <span
                      style={{
                        color: "#959595",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                        fontSize: "12px",
                      }}
                    >
                      {" "}
                      Modification taux commission
                    </span>
                  </div>

                  <span
                    style={{
                      color: "#2A2A2A",
                      fontWeight: "400",
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      marginLeft: "65px",
                    }}
                  >
                    Détails supplémentaires :
                  </span>
                  <span
                    style={{
                      color: "#959595",
                      fontWeight: "400",
                      fontFamily: "Poppins",
                      fontSize: "12px",
                    }}
                  >
                    {" "}
                    Taux Sénégal 2,5% --&gt; 2,8%
                  </span>
                </div>
              </Col>
            </Row>
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default JournalActivite;
